<template>
    <v-dialog v-model="addNotifyToDialog" @keydown.esc="addNotifyToDialog = false" persistent max-width="600px" retain-focus>
        <template v-slot:activator="{ on, addNotifyToAttrs }">
                <v-icon :color="groupSetting.mainColor" class="mt-1" v-bind="addNotifyToAttrs" v-on="on">mdi-account-plus</v-icon>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">시안 확인 알림 연락처 등록</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" class="mb-n8">
                            <v-text-field label="연락처 *" hint="연락처를 입력하세요." v-model="notifyToAttrs.phoneNumber" ref="phoneNumber" @focus="$event.target.select()" required></v-text-field>
                        </v-col>
                        <v-col cols="12" class="mb-n8">
                            <v-text-field label="이름 *" hint="이름을 입력하세요." v-model="notifyToAttrs.name" required></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
                <small>* 항목은 필수입니다.</small>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="saveNotifyTo">저장</v-btn>
                <v-btn color="blue darken-1" text @click="addNotifyToDialog = false">닫기</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";

export default {
    name: 'AddNotifyToButton',
    data: function() {
        return {
            addNotifyToDialog: false,
            notifyToAttrs: {
                id: null,
                phoneNumber: null,
                name: null
            },
            notifyToArray: [],
            groupSetting: null
        }
    },

    methods: {
        async saveNotifyTo() {

            return axios({
                method: 'POST',
                    headers: {
                        'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                    },
                    url: this.$store.getters.getApiUrl + '/api/v1/setting/saveNotifyTo',
                    data: this.notifyToAttrs,
                    timeout: this.$store.getters.getApiRequestTimeLimit
                })
                .then(response => {

                    if(response.data != null && response.data.status == '0000'){

                        alert('정상적으로 추가되었습니다.')
                        location.reload()

                    }else{

                        this.orders = []

                    }

                })
                .catch(() => {

                    //뭔가 실패 시
                    alert('연락처 저장에 실패했습니다.')
                    console.log(this.$el)
                    this.$rollbar.error('고객 주문내역 조회 실패', this.$el)

                })

        },
        clearData() {
            this.notifyToAttrs.id = null
            this.notifyToAttrs.phoneNumber = null
            this.notifyToAttrs.name = null
        }
    },
    mounted: function() {
        // this.$refs.phoneNumber.focus()
    },
    created: function() {
        this.groupSetting = this.$store.getters.getGroupSetting
    }
}
</script>